const logClipboardError = error => {
  const params = {
    userAgent: navigator.userAgent,
    secureContext: window.isSecureContext,
    hasClipboard: !!navigator.clipboard,
    hasWriteText: !!navigator.clipboard?.writeText,
    error,
  };

  console.error('Clipboard copy failed: ', params);
};

export const copyToClipboard = async text => {
  if (window.isSecureContext && navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      logClipboardError(error);
      throw error;
    }
  }

  // fallback for old browsers
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length); //to inshore that text selected for browser not supporting select()

    // using deprecated document.execCommand exactly for the purpose of supporting old browsers api
    document.execCommand('copy');

    document.body.removeChild(textarea);
  } catch (error) {
    logClipboardError(error);
    throw error;
  }
};
